import { IHomeStatistics } from "domain/Utils/models/IHomeStatistics";
import { SBBox } from "modules/Commons";
import SBForecastPeriodRange from "../SBForecastPeriodRange";
import SBForecastEvaluationSectionContainer from "../SBForecastEvaluationSectionContainer";

export default ({ breakLine, statistics, isCost, isMonthly = true, isOnModal, hideBenchmark }: SBForecastEvaluationSectionProps) => {
	return (
		<SBBox
			border="1px solid rgba(0,0,0,.1)"
			borderRadius="8px"
			py={3}
			width={1}
			style={{ position: "relative" }}
		>
			<SBForecastPeriodRange statistics={statistics} />
			<SBForecastEvaluationSectionContainer 
				statistics={statistics} 
				isMonthly={isMonthly} 
				breakLine={breakLine} 
				isCost={isCost} 
				isOnModal={isOnModal} 
				hideBenchmark={hideBenchmark} 
			/>
		</SBBox>
	);
};

interface SBForecastEvaluationSectionProps {
	statistics: IHomeStatistics;
	isMonthly?: boolean;
	breakLine?: boolean;
	isCost: boolean;
	isOnModal: boolean;
    hideBenchmark?: boolean;
}